















import mixins from 'vue-typed-mixins'

export default mixins().extend({
    data() {
        return {
            file: null as null | File,
            messageConfirmationUpload: ''
        }
    },
    methods: {
        ajouterFichier() {
            if (!this.file) return

            const formData = new FormData()
            formData.append('file', this.file)

            this.messageConfirmationUpload = ''
            this.$loader.go()
            this.$http
                .api(`/importUrlTelechargement`)
                .post(formData)
                .then(x => {
                    this.file = null
                    this.messageConfirmationUpload = "L'import s'est bien passé"
                    this.$swal.toast.success()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    }
})
